import styles from 'components/chat-components/AgentMessage.module.css'

import type { FunctionResultContent } from 'components/chat-components/AgentMessage.types'
import type { ReactElement } from 'react'

export const FunctionResultRenderer = ({ content }: { content: FunctionResultContent }): ReactElement => {
  /* --- Section 6: Render --- */
  return (
    <div className={styles.contentFunctionResult}>
      <span className={styles.functionResultIcon}></span>
      <span className={styles.functionResultName}>{content.name} completed</span>
    </div>
  )
}
